import React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
import { TouchableOpacity } from "react-native";
import { uniqueId } from 'lodash';

export default function UsersIcon(props) {
  const filterId = "paint0_linear" + uniqueId();
  const filterUrl = "url(#" + filterId + ")";


  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7729 3.02649C15.6034 2.85706 15.3296 2.85706 15.1601 3.02649L11.1332 7.05346L9.70622 5.62649C9.53678 5.45706 9.26291 5.45706 9.09348 5.62649C8.92405 5.79592 8.92405 6.06979 9.09348 6.23922L10.8268 7.97256C10.9113 8.05706 11.0222 8.09952 11.1332 8.09952C11.2441 8.09952 11.355 8.05706 11.4395 7.97256L15.7729 3.63922C15.9423 3.46979 15.9423 3.19592 15.7729 3.02649ZM9.89647 18.8375C9.204 18.2881 8.02924 17.6329 6.36654 17.6329C4.70384 17.6329 3.52907 18.2881 2.8366 18.8375C2.32614 19.2427 2.0332 19.8576 2.0332 20.5241V21.5329C2.0332 21.7725 2.2269 21.9662 2.46654 21.9662H10.2665C10.5062 21.9662 10.6999 21.7725 10.6999 21.5329V20.5241C10.6999 19.8576 10.4069 19.2427 9.89647 18.8375ZM8.96641 13.7329C8.96641 15.1688 7.80235 16.3329 6.36641 16.3329C4.93047 16.3329 3.76641 15.1688 3.76641 13.7329C3.76641 12.2969 4.93047 11.1329 6.36641 11.1329C7.80235 11.1329 8.96641 12.2969 8.96641 13.7329ZM21.1631 18.8375C20.4706 18.2881 19.2958 17.6329 17.6331 17.6329C15.9704 17.6329 14.7957 18.2881 14.1032 18.8375C13.5927 19.2427 13.2998 19.8576 13.2998 20.5241V21.5329C13.2998 21.7725 13.4935 21.9662 13.7331 21.9662H21.5331C21.7728 21.9662 21.9665 21.7725 21.9665 21.5329V20.5241C21.9665 19.8576 21.6735 19.2427 21.1631 18.8375ZM20.2332 13.7329C20.2332 15.1688 19.0691 16.3329 17.6332 16.3329C16.1973 16.3329 15.0332 15.1688 15.0332 13.7329C15.0332 12.2969 16.1973 11.1329 17.6332 11.1329C19.0691 11.1329 20.2332 12.2969 20.2332 13.7329Z"
          fill={filterUrl}
        />
        <Defs>
          <LinearGradient
            id={filterId}
            x1="2.0332"
            y1="7.03438"
            x2="10.9592"
            y2="26.1017"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
